/* ARRAY - THE PRODUCT RAIL. Arrows, counter, progress bar and drag.
   Shared by the supplements and baby care sections; it binds every
   [data-su-root] on the page, so the mirrored section needs no code of its own.
   The two rails are independent - each keeps its own scroll, counter and
   feature, because every piece of state below is per-root.

   IT IS AN ASSET WITH A DOMContentLoaded BOOT, not an inline script in a
   section. An inline script inside a section on this theme has bound to nothing
   before - see the head of snippets/beyondads-home-extra.liquid.

   BOTH SECTIONS EMIT THE <script> TAG, so this file is parsed twice on the
   homepage. The guard on the first line is what stops the second copy adding a
   second set of DOMContentLoaded and shopify:section:load listeners; build()
   is idempotent per root anyway, but two boots doing nothing is still two.

   ------------------------------------------------------------------------
   NO scroll-snap. NONE. The row free-scrolls and this file supplies the
   momentum. v1 of the phone carousel used scroll-snap-type:x mandatory and the
   client's verdict was "not smooth, it snappy... snapping one for another
   product"; snap also broke the arrows in three separate silent ways (a smooth
   scrollTo against mandatory snap is a no-op; per-frame scrollLeft writes are
   reverted; scrollend fires from the PREVIOUS glide). Do not add
   scroll-snap-type or scroll-snap-align back to .su-row.
   ------------------------------------------------------------------------

   THE ARROWS COUNT FROM A PENDING INDEX, NOT FROM THE LIVE SCROLL POSITION.
   A smooth scrollTo takes ~400ms, so two quick presses both read the same
   firstVisible() and both aim at the same card - the rail advances once and the
   second press looks broken. `pending` remembers where the rail is heading and
   is released once the glide has settled, or the moment the reader grabs the
   row themselves. This is the same class of bug as the scrollend one above:
   asking a scroller where it is while it is still moving.

   TWO DIFFERENT THINGS ARE TRACKED AND THAT IS ON PURPOSE, because the client's
   reference showed 01 in the counter while the SECOND card was the raised one:

     the COUNTER and the BAR follow the FIRST VISIBLE card - they answer "where
     am I in the rail", so at rest they read 01.
     the FEATURE (is-on: a larger bottle and a wider shadow) sits on the MIDDLE
     card of the window, or on whichever card the pointer is over.

   Falling back to the middle card is what makes it work on a phone, where there
   is no hover at all.

   THE LAST SCREENFUL IS THE ONE EXCEPTION TO "first visible". Three cards are
   on screen at once, so scrolling to the very end leaves the first visible card
   at 12 of 14 - the reader is looking at the end of the rail while the counter
   says there are two more and the bar sits at 86%. At the end it reports the
   last card, so the rail finishes on 14 / 14 and a full bar.

   NOTHING THE FEATURE CHANGES AFFECTS WIDTH. The bottle grows in height inside
   a fixed-height box, so moving the feature never reflows the row and never
   shifts the card under the reader's cursor mid-scroll. If a future change
   makes the featured card wider, the drag will start fighting the layout. */
(function () {
  'use strict';

  if (window.__beyondadsRail) return;
  window.__beyondadsRail = true;

  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FRICTION = 0.94;
  var DRAG_SLOP = 6;
  var SETTLE = 600;

  function two(n) { return n < 10 ? '0' + n : '' + n; }

  function build(root) {
    if (root.__su) return;
    root.__su = true;

    var row = root.querySelector('[data-su-row]');
    var cards = [].slice.call(root.querySelectorAll('[data-su-card]'));
    var iEl = root.querySelector('[data-su-i]');
    var nEl = root.querySelector('[data-su-n]');
    var fill = root.querySelector('[data-su-fill]');
    var prev = root.querySelector('[data-su-prev]');
    var next = root.querySelector('[data-su-next]');
    if (!row || !cards.length) return;

    var base = cards[0].offsetLeft;
    var hovered = -1;
    var feature = -1;
    var shown = -1;

    if (nEl) nEl.textContent = two(cards.length);

    function firstVisible() {
      var x = row.scrollLeft + 2;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].offsetLeft - base + cards[i].offsetWidth > x) return i;
      }
      return cards.length - 1;
    }

    function middle() {
      var mid = row.scrollLeft + row.clientWidth / 2;
      var best = 0, bd = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].offsetLeft - base + cards[i].offsetWidth / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function paint() {
      base = cards[0].offsetLeft;

      var f = hovered > -1 ? hovered : middle();
      if (f !== feature) {
        if (feature > -1) cards[feature].classList.remove('is-on');
        feature = f;
        cards[feature].classList.add('is-on');
      }

      var max = row.scrollWidth - row.clientWidth - 1;
      var atStart = row.scrollLeft <= 1;
      var atEnd = row.scrollLeft >= max;

      /* see the note at the top - the last screenful reports the last card */
      var i = atEnd ? cards.length - 1 : firstVisible();
      if (i !== shown) {
        shown = i;
        if (iEl) iEl.textContent = two(i + 1);
      }
      if (fill) fill.style.width = ((i + 1) / cards.length * 100) + '%';

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function go(i) {
      var left = cards[i].offsetLeft - cards[0].offsetLeft;
      if (REDUCED) { row.scrollLeft = left; paint(); return; }
      row.scrollTo({ left: left, behavior: 'smooth' });
    }

    /* see the note at the top on why this does not just read firstVisible() */
    var pending = null, settle = null;
    function nudge(dir) {
      var from = pending === null ? firstVisible() : pending;
      pending = Math.max(0, Math.min(cards.length - 1, from + dir));
      go(pending);
      clearTimeout(settle);
      settle = setTimeout(function () { pending = null; }, SETTLE);
    }

    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    for (var i = 0; i < cards.length; i++) {
      (function (n) {
        cards[n].addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          hovered = n;
          paint();
        });
        cards[n].addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'touch') return;
          if (hovered === n) hovered = -1;
          paint();
        });
      })(i);
    }

    var ticking = false;
    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    /* drag with momentum. The row is a native overflow-x scroller, so touch and
       trackpads already work; this is for a mouse. */
    var down = false, moved = false, startX = 0, startL = 0, lastX = 0, lastT = 0, vel = 0, glide = null;

    function stopGlide() { if (glide) { cancelAnimationFrame(glide); glide = null; } }

    function release() { clearTimeout(settle); pending = null; }

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') { release(); return; }
      if (e.button !== 0) return;
      stopGlide();
      release();
      down = true; moved = false;
      startX = lastX = e.clientX;
      startL = row.scrollLeft;
      lastT = performance.now();
      vel = 0;
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < DRAG_SLOP) return;
      if (!moved) { moved = true; row.classList.add('su-drag'); }
      e.preventDefault();
      row.scrollLeft = startL - dx;
      var t = performance.now();
      if (t > lastT) vel = (lastX - e.clientX) / (t - lastT) * 16;
      lastX = e.clientX; lastT = t;
    }, { passive: false });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      row.classList.remove('su-drag');
      if (!moved) return;
      /* one-shot capture-phase swallower, so letting go over a card does not
         open that product */
      row.addEventListener('click', function k(ev) {
        ev.preventDefault(); ev.stopPropagation();
        row.removeEventListener('click', k, true);
      }, true);
      (function step() {
        if (Math.abs(vel) < 0.4) { paint(); return; }
        row.scrollLeft += vel;
        vel *= FRICTION;
        glide = requestAnimationFrame(step);
      })();
    });

    window.addEventListener('resize', function () {
      base = cards[0].offsetLeft;
      release();
      paint();
    });

    paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint).catch(function () {});
    setTimeout(paint, 300);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-su-root]');
    for (var i = 0; i < roots.length; i++) build(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
